"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var promotion_1 = __importDefault(require("~/components/estimate_banners/promotion"));
var selling_point_1 = __importDefault(require("~/components/estimate_banners/selling_point"));
var link_button_1 = __importDefault(require("~/components/estimate_banners/inners/link_button"));
var top_medal_png_1 = __importDefault(require("images/common/top_medal.png"));
var EstimateBanner = function (props) {
    if (props.smartphone) {
        return (React.createElement("a", { href: props.path, rel: "nofollow", className: "estimateEntryBanner-Main estimateEntryBanner-LinkWithImageContainer show_bulk_banner js-ignore-blog-content-tracker", "data-analytics-track-event": props.analyticsData, "data-user-insight-track-event-click": props.userInsightEventData },
            React.createElement("div", { className: "estimateEntryBanner-LinkWithImage_AppealContainer" },
                React.createElement(promotion_1.default, { categoryName: props.categoryName, maxEstimateRequestSize: props.maxEstimateRequestSize, position: "right", withIcon: false, categoryIconClasses: props.categoryIconClasses, smartphone: true }),
                React.createElement(link_button_1.default, null),
                React.createElement(selling_point_1.default, null))));
    }
    else {
        return (React.createElement("a", { href: props.path, rel: "nofollow", className: "estimateEntryBanner-Main estimateEntryBanner-LinkWithImageContainer js-ignore-blog-content-tracker", "data-analytics-track-event": props.analyticsData, "data-user-insight-track-event-click": props.userInsightEventData },
            React.createElement("div", { className: "estimateEntryBanner-LinkWithImage_MedalContainer" },
                React.createElement("img", { src: top_medal_png_1.default, className: "estimateEntryBanner-LinkWithImage_MedalImage lazyload", alt: "Estimate Entry Banner", width: 133, height: 133 })),
            React.createElement("div", { className: "estimateEntryBanner-LinkWithImage_AppealContainer" },
                React.createElement(promotion_1.default, { categoryName: props.categoryName, maxEstimateRequestSize: props.maxEstimateRequestSize, position: "bottom", withIcon: false, categoryIconClasses: props.categoryIconClasses }),
                React.createElement(link_button_1.default, null),
                React.createElement(selling_point_1.default, null))));
    }
};
exports.default = EstimateBanner;
